import React, {useEffect} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import DashboardAdmin from '../../views/Dashboard/DashboardAdmin';
import DashboardOwner from '../../views/Dashboard/DashboardOwner';
import DashboardFBO from '../../views/Dashboard/DashboardFBO';
import DashboardFarmer from "../../views/Dashboard/DashboardFarmer";

import Request from '../../views/Request/';

import FarmersAdmin from '../../views/Farmers/FarmersAdmin';
import FarmersFBO from '../../views/Farmers/FarmersFBO';

import FBOs from '../../views/FBOs/';

import TractorsAdmin from '../../views/Tractors/TractorsAdmin';
import TractorsOwner from '../../views/Tractors/TractorsOwner';

import Owners from '../../views/Tractorowners';

import OperatorsAdmin from '../../views/Operators/OperatorsAdmin';
import OperatorsOwner from '../../views/Operators/OperatorsOwner';

import Transactions from '../../views/Transactions/';

import MapsAdmin from '../../views/Maps/MapAdmin';
import MapsOwner from '../../views/Maps/MapOwner';
import UserFeedback from '../../views/Extras/UserSupport/Feedback';
import TractorOwnerPayout from '../../views/Extras/Finance/TractorOwnerPayouts/TractorOwnerPayouts';

import Notifications from 'react-notify-toast';

import RouterPrivate from '../../common/RouterPrivate';
import USSDServices from '../../views/Extras/Services/USSDServices';
import SettingsView from '../../views/Management/Settings';

import AcreageOwner from '../../views/Acreage/AcreageOwner';
import PlatformRender from "../../components/PlatformRender/PlatformRender";
import {DevicePlatforms, Permissions, UserDepartments, UserRoles} from "../../common/Constants";
import {ToastContainer} from "react-toastify";
import TTLProxy from "../../common/TTLAsyncProxy";
import TractorRequestHandler from "../../components/TractorRequestHandler/TractorRequestHandler";
import AppGlobals from "../../common/AppGlobals";
import {LocalSettingsManager} from "../../common/LocalSettings/LocalSettings";
import RevenueView from '../../views/Revenue';
import {ToastsContainer, ToastsContainerPosition, ToastsStore} from "react-toasts";
import AcreageFarmer from "../../views/Acreage/AcreageFarmer";
import AcreageFBO from "../../views/Acreage/AcreageFBO";
import history from '../../history';
import {subscribeNotificationChannels} from "../../common/UserNotifications/Subscriptions";
import PermissionRender from "../../components/PermissionRender/PermissionRender";
import BankPayments from "../../views/Extras/Finance/CommandAgriculture/BankPayments/BankPayments";
import CreateBankPayment from "../../views/Extras/Finance/CommandAgriculture/CreateBankPayment/CreateBankPayment";
import BankPaymentDetail from "../../views/Extras/Finance/CommandAgriculture/BankPaymentDetail/BankPaymentDetail";

/**
 * Place additional page info here
 * @private
 */
const _PagesInfo = [
    {
      url: "/maps",
      ignoreBreadcrumbs: true,
      showFooter: false,
      mainStyle: {
          background: "white"
      }
    },
    {
      url: '/request/',
      ignoreBreadcrumbs: true,
      showFooter: true
    }
];

function getPageInfo(path) {
    return  _PagesInfo.find(x => path.startsWith(x.url));
}

function ignoreBreadcrumbs(path){

    const pageInfo = getPageInfo(path);
    if(pageInfo){
        return pageInfo.ignoreBreadcrumbs;
    }

}

function showFooter(path) {

    const pageInfo = getPageInfo(path);
    if(pageInfo)
        return pageInfo.showFooter;

    return true;
}

const CustomBreadcrumbs = (props) => {

    const pageInfo = getPageInfo(props.path);
    if(pageInfo && pageInfo.hasOwnProperty('view')){
        return typeof pageInfo.view === "function" ? pageInfo.view() : pageInfo.view;
    }

    return <Breadcrumb/>;
};

function Full({ }) {

    const proxy = TTLProxy.getInstance();

    useEffect(() => {

        const settings = AppGlobals.get('settings');
        const user = proxy.getUserInfo();

        if(!settings && proxy.isAuthenticated()){

            //  Do the favor of restoring global setting
            AppGlobals.set( 'settings' , LocalSettingsManager.get(user.id) );
        }


        (async function (){

            //  init user notifications
            await subscribeNotificationChannels(user);

        })();


        //  Cleanup callback
        return function () {

            //  remove global request handler reference to prevent memory leaks
            AppGlobals.remove('tractorRequestHandler');

        };

    },[]);


    const pageInfo = getPageInfo(history.location.pathname);

    return (<div className="app">

            {/*Notifications container*/}
            <Notifications options={{zIndex: 5000}}/>

            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER}/>

            {/*Declare one toast container for all toasts*/}
            <ToastContainer
                position="top-right"
                type="default"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                style={{zIndex: 50004 }}/>

            <Header/>

            <div className="app-body">

                <Sidebar/>

                <main className="main" style={ (pageInfo ? pageInfo.mainStyle : null) || {} }>

                    {!ignoreBreadcrumbs(history.location.pathname) && <PlatformRender platform={DevicePlatforms.Desktop}>
                        <CustomBreadcrumbs path={history.location.pathname}/>
                    </PlatformRender>}

                    <Switch>

                        <RouterPrivate path="/dashboard" name="Dashboard" components={[
                            { role: UserRoles.Admin , component: DashboardAdmin },
                            { role: UserRoles.Owner , component: DashboardOwner },
                            { role: UserRoles.FBO , component: DashboardFBO },
                            { role: UserRoles.Farmer , component: DashboardFarmer }
                        ]}  roles={[ UserRoles.Admin , UserRoles.Owner , UserRoles.FBO , UserRoles.Farmer  ]}/>

                        <RouterPrivate path="/requests" permissions={[ Permissions.Requests.View ]} name="Requests" components={[
                            { role:  UserRoles.Admin , component: Request },
                            { role: UserRoles.Owner , component: AcreageOwner },
                            { role: UserRoles.Farmer , component: AcreageFarmer },
                            { role: UserRoles.FBO , component: AcreageFBO }
                        ]}  roles={[UserRoles.Admin , UserRoles.Owner , UserRoles.FBO , UserRoles.Farmer ]}/>


                        <RouterPrivate path="/farmers" permissions={[ Permissions.Farmers.View ]} name="Farmers" components={[
                            { role: UserRoles.Admin , component: FarmersAdmin },
                            { role: UserRoles.FBO , component: FarmersFBO }
                        ]} roles={[ UserRoles.Admin , UserRoles.FBO ]}/>

                        <RouterPrivate path="/fbo" permissions={[ Permissions.FBO.View ]}  name="FBOs" component={FBOs}  roles={[ UserRoles.Admin ]} />

                        <RouterPrivate path="/tractors" permissions={[ Permissions.Tractors.View ]} name="Tractors" components={[
                            { role: UserRoles.Admin , component: TractorsAdmin },
                            { role: UserRoles.Owner , component: TractorsOwner }
                        ]}  roles={[ UserRoles.Admin , UserRoles.Owner ]}/>

                        <RouterPrivate path="/tractor_owners" permissions={[ Permissions.TractorOwners.View ]} name="TractorOwners" component={Owners} roles={[UserRoles.Admin]}/>

                        <RouterPrivate path="/operators" permissions={[ Permissions.Operators.View ]} name="Operators" components={[
                            { role: UserRoles.Admin , component: OperatorsAdmin },
                            { role: UserRoles.Owner , component: OperatorsOwner }
                        ]} roles={[  UserRoles.Admin , UserRoles.Owner ]}/>

                        <RouterPrivate path="/transactions" permissions={[ Permissions.Transactions.View ]}  name="Transactions" component={Transactions}  roles={[UserRoles.Admin]}/>

                        <RouterPrivate path="/maps" permissions={[ Permissions.User.MonitorTrackers ]} name="Maps" components={[
                            { role: UserRoles.Admin , component: MapsAdmin },
                            { role: UserRoles.Owner , component: MapsOwner },
                        ]} roles={[UserRoles.Admin , UserRoles.Owner]}/>

                        {/*<RouterPrivate path="/account/tickets" name="TicketManagement" component={UserTickets}/>*/}

                        {/*<RouterPrivate path="/support/tickets_management" name="UserTickets" component={TicketsAdminManagement} roles={[UserRoles.Admin]} departments={[UserDepartments.IT]}/>*/}

                        <RouterPrivate path="/support/feedback" name="Feedback" component={UserFeedback} roles={[UserRoles.Admin]} />

                        <RouterPrivate path="/finance/payout" name="Payout" component={TractorOwnerPayout} roles={[UserRoles.Admin]} departments={[UserDepartments.Finance]}/>

                        <RouterPrivate path="/finance/command/agric/payments" permissions={[ Permissions.CommandAgriculture.View ]} name="CommandAgriculture" roles={[UserRoles.Admin]} component={BankPayments}/>

                        <RouterPrivate path="/finance/command/agric/create/payment" permissions={[ Permissions.CommandAgriculture.Create ]} name="CommandAgricultureCreateBankPayment" roles={[UserRoles.Admin]} component={CreateBankPayment}/>

                        <RouterPrivate path="/finance/command/agric/payment/detail/:id" permissions={[ Permissions.CommandAgriculture.View , Permissions.CommandAgriculture.Edit ]} name={"CommandAgricultureEditPayment"} roles={[UserRoles.Admin]} component={BankPaymentDetail}/>

                        <RouterPrivate path="/payments" name="Payments" permissions={[ Permissions.Payments.View ]} component={RevenueView} roles={[UserRoles.Owner]}/>

                        {/* <RouterPrivate path="/users" name="Users" component={Users}  roles={[ UserRoles.Admin ]}/> */}

                        {/*Extras Routes*/}
                        <RouterPrivate path="/services/ussd" permissions={[ Permissions.USSDServices.View ]} name="USSD" roles={[UserRoles.Admin]} component={USSDServices} />

                        {/*<RouterPrivate path="/services/broadcast" name="Broadcasting" roles={[UserRoles.Admin]} component={Broadcast} />*/}

                        <RouterPrivate path="/management/settings" name="Settings" roles={[UserRoles.Admin]} component={SettingsView} requireSuperUser={true} />


                        {/*<RouterPrivate path="/extras" name="Extras" component={Extras} history={this.props.history} roles={[UserRoles.Admin]} />*/}

                        <Route path="/" exact={true} render={() => {

                            const proxy = TTLProxy.getInstance();
                            if(proxy.isAuthenticated()){
                                return <Redirect to="/dashboard"/>;
                            }

                            return <Redirect to="/page-not-found"/>;

                        }}/>

                        <Redirect to="/page-not-found"/>

                    </Switch>
                </main>
                <Aside />

                <PermissionRender roles={[UserRoles.Admin,UserRoles.CallCenterAgent]} required={[Permissions.Requests.View]}>
                    <TractorRequestHandler ref={r => AppGlobals.set('tractorRequestHandler',r) }/>
                </PermissionRender>

            </div>
            {showFooter(history.location.pathname) && <Footer />}
        </div>

    );
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js